module.exports = __webpack_public_path__ + "img/red.ad55da9e.svg";